import React, { useEffect, useState } from 'react'
import Label from "components/general/Label";
import Moment from 'react-moment';
import Status from "components/presentation/Status"
import { Score as ScoreGlobal } from "components/presentation/Score"
import Competitor from 'components/presentation/Competitor';
import Noc from 'components/presentation/Noc';
import { Stack } from 'react-bootstrap';
import SportCode, { getSportCodeObject, useSportCodeTranslation } from '../SportCode';
import Discipline from 'components/presentation/Discipline';
import Medal from 'components/presentation/Medal';
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQueryClient } from 'react-query';

export function ColumnTime(globalProps, {
  disableSort = false,
  label = "HeaderTime",
  dataSportCodes = []
}) {

  return (
    {
      Header: <Label data={label} />,
      accessor: (props) => {
        return (props?.startDate + props?.order)
      },
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        const hideStart = row.hideStartDate
        const hideEnd = row.hideEndDate
        const sportCode = getSportCodeObject(dataSportCodes, discipline, "@StartText", row?.startText)
        let  startText = (hideStart && row?.startText) ? sportCode?.description || row.startText : ''
                 

        return (
          <>
            <div className='text-wrap'>{startText}</div>

            { !hideStart &&
              <Moment tz={globalProps.timezone} format="HH:mm">
                {row?.startDate}
              </Moment>
            }
            { !hideEnd &&
              <>
                <Label data="LabelFinishOn" />&nbsp;
                <Moment tz={globalProps.timezone} format="MMM Do">
                  {row?.endDate}
                </Moment>
              </>
            }
          </>
        )
      }
    }
  )
}

export function ColumnEvent({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event'
    }
  )
}

export function ColumnEventWithCompetitor({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        const eventDesc = row?.discipline?.code === 'BDM' ? (row?.eventUnit?.shortDescription || row?.eventUnit?.longDescription) : row?.eventUnit?.longDescription      
        const isH2H = row?.eventUnit?.type.startsWith("H")
        const discipline = row?.discipline?.code
        const rsc = row?.code
        const resultStatus = props.cell.row.original?.result?.status?.code
        const scheduleStatus = props.cell.row.original?.status?.code

        const h2hOut = (
          <Stack direction='vertical'>
          <div className='text-wrap'>{eventDesc}</div>
            <Stack direction='horizontal'>
              <Stack direction='vertical' className='schedule-competitor w-70'>
                  {row?.result?.items?.map(item => {
                    return (
                      <Stack direction='horizontal'>
                        <Noc {...item?.participant?.organisation} showOnlyImage={true}/>
                        <Competitor {...item?.participant} hidePicture={true} hideNoc={true} key={`participant-${rsc}-${item?.participant?.code}`} small={true}/>
                      </Stack>                    
                    )})
                  }
              </Stack>
              <Stack direction='vertical' className='schedule-result'>
                  {row?.result?.items?.map(item => {
                    return (
                      <ScoreGlobal resultJson={item?.resultDataText} discipline={discipline} key={`score-${rsc}-${item?.sortOrder}`} resultStatus={resultStatus} type={'SCHEDULE'} />
                    )})
                  }
              </Stack>             
            </Stack>
          <div className='w-100 text-end'>           
            <Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
          </div>
        </Stack>
        )
        
        const h2hOut2 = (
          <div className='container'>
            <div className='row'>
              <div className='col-12 text-wrap'>{eventDesc}</div>
            </div>
            { row?.result?.items?.map(item => {
                        return (
                            <div className='row'>
                              <div className='col-1'><Noc {...item?.participant?.organisation} showOnlyImage={true}/></div>
                              <div className='col-8'><Competitor {...item?.participant} hidePicture={true} hideNoc={true} key={`participant-${rsc}-${item?.participant?.code}`} small={true}/></div>
                               <div className='col-3'><ScoreGlobal resultJson={item?.resultDataText} discipline={discipline} key={`score-${rsc}-${item?.sortOrder}`} resultStatus={resultStatus} type={'SCHEDULE'} /></div>
                            </div>
                        )})
                      }

            <div className='row'>
              <div className='col-12 text-end'><Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} /></div>
            </div>
        </div>
        )

        const standardOut = (
          <div className='d-flex justify-content-between'>
            <div className='text-wrap'>{eventDesc}</div>
            <div className='text-end'>           
              <Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
            </div>
          </div>
      )

        
        return isH2H ? h2hOut : standardOut;
        
        
      }
    }
  )
}

export function ColumnEventWithCompetitorAndTime(globalProps, {
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        const eventDesc = row?.eventUnit?.longDescription
        const isH2H = row?.eventUnit?.type.startsWith("H")
        const discipline = row?.discipline?.code
        const rsc = row?.code
        const resultStatus = props.cell.row.original?.result?.status?.code
        const scheduleStatus = props.cell.row.original?.status?.code
        
        const hideEnd = row.hideEndDate
        const startText = row.startText
        return (
          <Stack direction='vertical' className="w-90">
            <Stack direction='horizontal' className="fw-bold">
            {startText &&
              <SportCode code={startText} discipline={discipline} entity="@StartText" />
            }
              <Moment tz={globalProps.timezone} format="MMM Do HH:mm">
                {row?.startDate}
              </Moment>
            </Stack>
            <div className='text-truncate'>{eventDesc}</div>
            <Stack direction='horizontal'>
              <Stack direction='vertical' className='schedule-competitor w-70'>
                {isH2H && row?.result?.items?.map((item) => {
                  return (
                    <Stack direction='horizontal'>
                      <Noc {...item?.participant?.organisation} showOnlyImage={true}/>
                      <Competitor {...item?.participant} hidePicture={true} hideNoc={true} key={`participant-${rsc}-${item?.participant?.code}`} />
                    </Stack>                    
                  )
                })}
              </Stack>
              <Stack direction='vertical' className='schedule-result'>
                {isH2H && row?.result?.items?.map((item) => {
                  return (
                    <ScoreGlobal resultJson={item?.resultDataText} discipline={discipline} key={`score-${rsc}-${item?.sortOrder}`} />
                  )
                })}
              </Stack>              
            </Stack>
            <div className='w-100 text-end'>            
              <Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
            </div>
          </Stack>
        )
        
      }
    }
  )
}

export function ColumnCompetitor({
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-competitor',
      headerClassName: 'schedule-competitor',
      disableSortBy: true,
      id: 'Competitor',
      Cell: (props) => {
        const { mirs_discipline } = useUrlFriendlyToParameters()
        const row = props.cell.row.original
        const isH2H = row?.eventUnit?.type.startsWith("H")
        const isGoldMedal = (row?.eventUnit?.medal === 1)
        const medallist = row?.eventUnit?.phase?.event?.medallists
        const rsc = row?.code

        return (
          <>
            {isH2H && row?.result?.items?.sort((a, b) => a.startSortOrder - b.startSortOrder).map((item) => {
              let competitorPlace;
              competitorPlace = item?.itemType === 'T' ? item?.teamCode : item?.athleteCode
              return (
                <Stack direction='horizontal' key={`participant-${rsc}-${item?.participant?.code}`}>
                  <div className="d-none d-md-inline"><Noc {...item?.participant?.organisation} /></div>
                  {(competitorPlace?.includes('BYE') || competitorPlace?.includes('NOCOMP'))
                    ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitorPlace} />
                    : <Competitor {...item?.participant} hideNoc={true} hidePicture={true} key={`participant-${rsc}-${item?.participant?.code}`} />}
                </Stack>
              )
            })}
            {!isH2H && isGoldMedal && medallist && medallist.sort((a, b) => a.medal_type - b.medal_type).map((m) => {
              return (
                <Stack direction='horizontal' key={`medallist-${rsc}-${m?.medal_type}`}>
                  <Medal code={m?.medal_type} showImage={true}/>
                  <div className="d-none d-md-inline"><Noc {...m?.participant?.organisation} /></div>
                  <Competitor {...m?.participant} hideNoc={true} hidePicture={true} />
                </Stack>
              )
            })}
          </>
        )
      }
    }
  )
}

export function ColumnResult({
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-result',
      headerClassName: 'schedule-result',
      disableSortBy: true,
      id: 'Result',
      Cell: (props) => {
        const row = props.cell.row.original
        const isH2H = row?.eventUnit?.type.startsWith("H")
        const discipline = row?.discipline?.code
        const rsc = row?.code
        return (
          <>
            {isH2H && row?.result?.items?.sort((a, b) => a.startSortOrder - b.startSortOrder).map((item) => {
              return (
                <ScoreGlobal resultJson={item?.resultDataText} discipline={discipline} key={`score-${rsc}-${item?.sortOrder}`} />
              )
            })}
          </>
        )
      }
    }
  )
}

export function ColumnLocation({
  disableSort = false,
  label = "HeaderLocation"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'location.locationOrder',
      className: 'schedule-location',
      headerClassName: 'schedule-location',
      disableSortBy: disableSort,
      id: 'Location',
      Cell: (props) => {
        return (
          props.cell.row.original?.location?.shortDescription
        )
      }
    }
  )
}

export function ColumnLocationNOC({
  disableSort = false,
  label = "HeaderLocation"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'location.shortDescription',
      className: 'schedule-location',
      headerClassName: 'schedule-location',
      disableSortBy: disableSort,
      id: 'Location',
      Cell: (props) => {
        return (
          props.cell.row.original?.location?.shortDescription
        )
      }
    }
  )
}

export function ColumnSession(globalProps, {
  disableSort = false,
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'session.startDate',
      className: 'schedule-session',
      headerClassName: 'schedule-session',
      disableSortBy: disableSort,
      id: 'Session',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        return (
          <Stack direction='horizontal'>
            <div className="px-2">
              <SportCode code={row?.session?.code} discipline={discipline} entity="@Session" />
            </div>
            <div className="px-1">
              <Moment tz={globalProps.timezone} format="HH:mm">
                {row?.session?.startDate}
              </Moment>
            </div>
            <div className="px-1">-</div>
            <div className="px-1">
              <Moment tz={globalProps.timezone} format="HH:mm">
                {row?.session?.endDate}
              </Moment>
            </div>
          </Stack>
        )
      }
    }
  )
}

export function ColumnStatus({
  label = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-status',
      headerClassName: 'schedule-status',
      disableSortBy: true,
      id: 'Status',
      Cell: (props) => {
        const resultStatus = props.cell.row.original?.result?.status?.code
        const scheduleStatus = props.cell.row.original?.status?.code
        return (
          <Status typeToPrint='schedule' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
        )
      }
    }
  )
}

export function ColumnDiscipline({
  disableSort = false,
  showDescription = true,
  label = "HeaderDiscipline"
}) {
  return (
    {
      Header: <Label data={label}/> ,
      accessor: (props) => (props?.discipline?.description?.toUpperCase()),
      className: 'schedule-discipline',
      headerClassName: 'schedule-discipline',
      disableSortBy: disableSort,
      id: 'Discipline',
      Cell: (props) => {
        return (
          <Discipline showDescription={showDescription} code={props.cell.row.original?.discipline?.code} description={props.cell.row.original?.discipline?.description} />
        )
      }
    }
  )
}


export function ColumnDateTime(globalProps, {
  disableSort = false,
  label = "HeaderTime"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        const hideEnd = row.hideEndDate
        const startText = row.startText
        return (
          <>
            {startText &&
              <SportCode code={startText} discipline={discipline} entity="@StartText" />
            }
            {
              <Moment tz={globalProps.timezone} format="MMM Do HH:mm">
                {row?.startDate}
              </Moment>
            }
            {!hideEnd &&
              <>
                <Label data="LabelFinishOn" />&nbsp;
                <Moment tz={globalProps.timezone} format="MMM Do">
                  {row?.endDate}
                </Moment>
              </>
            }
          </>
        )
      }
    }
  )
}

export function ColumnDateTimeNOC(globalProps, {
  disableSort = false,
  label = "HeaderTime"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Time',
      Cell: (props) => {
        const row = props.cell.row.original
        const discipline = row?.discipline?.code
        const hideEnd = row.hideEndDate
        const startText = row.startText
        return (
          <>
            <Stack direction='horizontal'>

              {startText &&
                <SportCode code={startText} discipline={discipline} entity="@StartText" />
              }
              {
                <Moment tz={globalProps.timezone} format="MMM Do HH:mm">
                  {row?.startDate}
                </Moment>
              }
              {//!hideEnd &&
                // <>
                //   <Label data="LabelFinishOn" />&nbsp;
                //   <Moment tz={globalProps.timezone} format="MMM Do">
                //     {row?.endDate}
                //   </Moment>
                // </>
              }
            </Stack>
          </>
        )
      }
    }
  )
}

export function ColumnDate(globalProps, {
  disableSort = false,
  label = "HeaderDate"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startDate',
      className: 'schedule-time',
      headerClassName: 'schedule-time',
      disableSortBy: disableSort,
      id: 'Date',
      Cell: (props) => {
        const row = props.cell.row.original

        return (
          <Moment tz={globalProps.timezone} format="MMM Do">
            {row?.startDate}
          </Moment>
        )
      }
    }
  )
}

export function ColumnNocCompetitor({
  label = "",
  nocToShow = ""
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'schedule-competitor',
      headerClassName: 'schedule-competitor',
      disableSortBy: true,
      id: 'Competitor',
      Cell: (props) => {
        const row = props.cell.row.original
        const rsc = row?.code
        const isH2H = row?.eventUnit?.type.startsWith("H")
        return (
          <>
            {row?.result?.items?.map((item) => {
              if (isH2H || (!isH2H && item?.participant?.organisation?.code == nocToShow)) {
                return (
                  <Stack direction='horizontal' key={`participant-${rsc}-${item?.participant?.code}`}>
                    <div className="d-none d-md-inline"><Noc {...item?.participant?.organisation} /></div>
                    <Competitor {...item?.participant} hideNoc={true} hidePicture={true} />
                  </Stack>
                )
              }
            })}
          </>
        )
      }
    }
  )
}

export function ColumnNoc({

  disableSort = false,
  className = 'text-start',
  headerClassName = 'text-start w-20',
  label = 'HeaderNOC',
  remove = false
}) {

  const competition = CompetitionFromStore();
  if (isParalympic(competition) && label === 'HeaderNOC') {
    label = 'HeaderNPC';
  }

  return (
    {
      Header: <Label data={label} />,
      id: 'NOC',
      accessor: 'organisation.code',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      remove: remove,
      Cell: (props) => {
        const row = props.cell.row.original
        let data = props.cell.row.original?.organisation
        return (<Noc {...data} showLongDesc={true} />)
      }
    }
  )

}

export function ColumnMedal({
  disableSort = false,
  label = "HeaderMedal"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'location.locationOrder',
      className: 'medallist-medal',
      headerClassName: 'medallist-medal',
      disableSortBy: disableSort,
      id: 'Medal',
      Cell: (props) => {
        return (
          <Medal code={props.cell.row.original?.medal_type} />
        )
      }
    }
  )
}

export function ColumnMedalEvent({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'event.longDescription',
      className: 'medals-event',
      headerClassName: 'medals-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        return (
          props.cell.row.original?.event?.longDescription
        )
      }
    }
  )
}

export function ColumnEventNOC({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.shortDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event'
    }
  )
}

export function ColumnMedalEventWithCompetitor({
  disableSort = false,
  label = "HeaderEvent"
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'eventUnit.longDescription',
      className: 'schedule-event',
      headerClassName: 'schedule-event',
      disableSortBy: disableSort,
      id: 'Event',
      Cell: (props) => {
        const row = props.cell.row.original
        const eventDesc = row?.eventUnit?.longDescription
        const discipline = row?.discipline?.code
        return (
          <Stack direction='vertical'>
            <div>{eventDesc}</div>
            <Stack direction='horizontal'>
              <div className="d-none d-md-inline"><Noc {...row?.participant?.organisation} /></div>
              <Competitor {...row?.participant} hideNoc={false} hidePicture={true} key={`participant-${row?.participant?.code}`} />
            </Stack>
          </Stack>
        )
      }
    }
  )
}

export function ColumnMedalCompetitor({
  label = "LabelCompetitor",
  disableSort = false
}) {
  return (
    {
      Header: <Label data={label} />,
      className: 'medal-competitor',
      headerClassName: 'medal-competitor',
      disableSortBy: true,
      id: 'Competitor',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <>
            <Stack direction='horizontal' key={`participant-${row?.participant?.code}`}>

              <Competitor {...row?.participant} alwaysNoc={false} hideNoc={true} hidePicture={true} key={`participant-${row?.participant?.code}`} />
            </Stack>
          </>
        )
      }
    }
  )
}